import Vue from 'vue'
import VueDragScroll from 'vue-dragscroll'

Vue.use(VueDragScroll)
